<script>
import { mapGetters, mapState } from 'vuex'
export default {
    props: {
        produtoId: Number,
        embalagem: Number,
        produtoStatus: {
            type: String,
            default: 'not-blocked'
        },
    },
    data: function() {
        return {
            app: ROOT_URL,
            quantidade: 0,
			loading: false,
            isFavorited:false,
            blockedStatus: this.produtoStatus,
        };
    },
    methods: {
        checkQuantity: function() {
            if(this.adicionado == -1)
            {   
                this.quantidade = parseInt(this.embalagem ? Math.ceil(this.quantidade / this.embalagem) * this.embalagem : this.quantidade);
            }
        },
        incrementa: function() {
            if(this.adicionado == -1)
            {
                this.quantidade += this.embalagem;
            }
        },
        decrementa: function() {
            if(this.adicionado == -1)
            {
                this.quantidade = Math.max(0, this.quantidade - this.embalagem);
            }
        },
        adicionar: function() {
            var vm = this,
                produto = {
                    produto_id: this.produtoId,
                    embalagem: this.embalagem,
                    quantidade: this.quantidade
                };
            vm.loading = true;
            
            this.$store.dispatch('cart/addProduct', produto)
                .then(result => {
                    vm.$toasted.success('Produto adicionado', {duration:3000, keepOnHover: true});
			        vm.loading = false;
                })
                .catch(error => {
                    vm.$toasted.error(error, {duration:3000, keepOnHover: true, icon:'exclamation-circle'});
 			        vm.loading = false;
               });
        },
        handleFav: function (event) {
            event.preventDefault();
            this.isFavorited = !this.isFavorited;
        },
        requestNotification() {
            this.loading = true;

            const data = {
                product_id: this.produtoId
            }

            this.axios.post(`${API_URL}/produtos-bloqueados/solicitar-notificacao`, data ).then(()=>{
                this.blockedStatus = 'requested-notification';
                this.$fire({
                    title: 'Aviso programado com sucesso!',
                    text: 'Você receberá um e-mail quando este produto estiver disponível para compra.',
                    type: 'success',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false,
                    customClass:   {
                        title: 'notification-alert-title',
                        confirmButton: 'notification-alert-confirm',
                        content: 'notification-alert-text'
                    }
                })
            }).catch(()=>{
                this.$toasted.error('Erro ao solicitar aviso de chegada', {
                    duration:3000, 
                    keepOnHover: true, 
                    icon:'exclamation-circle'
                });      
            }).finally(()=>{
                this.loading = false;
            })
        },
    },
    mounted() {
        this.quantidade = this.embalagem;
    },
    computed: {
        ...mapState({
        	products: state => state.cart.products,
        	isLoading: state => state.cart.isLoading
        }),
        adicionado: function() {
            var returnKey = -1;
            var busca = this.produtoId;
            $.each(this.products, function(key, info) {                
                if (info.produto_id == busca) {
                returnKey = key;
                return false; 
                };   
            });
            return returnKey; 
        }
    }
};
</script>